<template>
	<div class="template tips">
		<div class="panel_wrap">
			<div class="panel_tips" v-for='(item,index) in dataVal.Property.Placeholder' :key='index' >{{item.Text}}</div>
		</div>
	</div>
</template>

<script>
	export default{
		props: ['dataVal'],
		data(){
			return{
				
			}
		}
	}
</script>

<style>
	@import '../../assets/css/common.css';
</style>
